import { fetchSettings, getAppVersion } from '@connect-x-app/hybrid-data-access';
import { ApiError, QueryKeys, SettingsItems, Version } from '@connect-x-app/shared-domain-models';
import { useQuery } from '@tanstack/react-query';

export const useGetSettings = () =>
  useQuery<SettingsItems, ApiError>({
    queryFn: fetchSettings,
    queryKey: [QueryKeys.SETTINGS],
  });

export const useGetAppVersion = () =>
  useQuery<Version, ApiError>({
    initialData: () => ({ minVersionAndroid: '0.0.0', minVersionIOS: '0.0.0' }),
    queryFn: getAppVersion,
    queryKey: [QueryKeys.VERSION],
    staleTime: 0,
  });
